import { NavLink } from 'react-router-dom';
import { isParaSetupEnabled } from 'src/config/features';
import { useIsAdmin } from 'src/hooks/useIsAdmin';
import { IconCalendarCheck, IconKidStudent, IconMoney, IconUser } from 'src/icons';
import { routes } from 'src/routes';

import { filterNavItems } from './filterNavItems';
import NavigationButton from './NavigationButton';

const NAV_ITEMS = [
  { label: 'Schedule', to: routes.schedule.root, Icon: IconCalendarCheck },
  { label: 'Students', to: routes.students, Icon: IconKidStudent },
  { label: 'Invoices', to: routes.billing.root, Icon: IconMoney },
  { label: 'Users', to: routes.users.root, Icon: IconUser, adminOnly: true },
  {
    label: 'Para setup',
    to: routes.adminSetup.root,
    Icon: IconKidStudent,
    adminOnly: true,
    preview: true,
  },
];

type NavigationLinksProps = {
  isCollapsed: boolean;
  showNotifications?: boolean;
  clickLinkCb?: () => void;
};

const NavigationLinks = ({ isCollapsed, clickLinkCb }: NavigationLinksProps) => {
  const isAdmin = useIsAdmin();
  const visibleItems = filterNavItems(NAV_ITEMS, {
    isAdmin: !!isAdmin,
    previewEnabled: isParaSetupEnabled(import.meta.env.VITE_ENV),
  });

  return (
    <>
      {visibleItems.map((item) => (
        <NavLink key={item.to} to={item.to}>
          {({ isActive }) => (
            <NavigationButton
              isActive={isActive}
              Icon={item.Icon}
              label={item.label}
              isCollapsed={isCollapsed}
              title={item.label}
              onClick={clickLinkCb}
            />
          )}
        </NavLink>
      ))}
    </>
  );
};

export default NavigationLinks;
